import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewDealsList = (dealsData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_DEALS_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/offer/list`,
        dealsData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_DEALS_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_DEALS_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_DEALS_LIST_FAILED",
        payload: error?.data?.response?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
export const viewDeal = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_DEAL_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/offer/view/${id}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_DEAL_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_DEAL_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_DEAL_FAILED",
        payload: error?.data?.response?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
}

export const addNewDeal = (dealsData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_DEALS_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/offer/add`,
        dealsData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_DEALS_LIST_SUCCESS", payload: data });
        toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_DEALS_LIST_FAILED", payload: data });
        toast.error("Something Went Wrong!!");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "ADD_DEALS_LIST_FAILED",
        payload: error?.data?.response?.message,
      });
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
export const updateDeal = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_DEAL_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/offer/update`,
          payload,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_DEAL_SUCCESS", payload: data });
        toast.success("Updated Successfully!");
        return data;
      } else {
        dispatch({ type: "UPDATE_DEAL_FAILED", payload: data });
        toast.error("Something Went Wrong!!");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_DEAL_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Error updating deal");
      return error?.response?.data;
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
